import { render, staticRenderFns } from "./detailApproval.vue?vue&type=template&id=f39dd3b8"
import script from "./detailApproval.vue?vue&type=script&lang=js"
export * from "./detailApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports